import { useParams } from "react-router";
import { PostEdit } from "./PostEdit";

export function PostEditPage() {
  const { id } = useParams();

  return <PostEdit id={id} />;
}
